import { bludeltaRequest, BluDeltaResponse } from './network';
import { getToken } from './auth';
import { DetectInvoiceResponse } from './detectInvoice';
import { InvoiceContainer, normalizeInvoiceContainers } from './invoiceContainer';

export interface InvoicePage {
  PageNo: number;
  PreviewSrc: string;
  Src: string;
}

export interface Invoice {
  InvoiceId: UUID;
  InvoiceState: string;
  BadClientId: string;
  BadSupplierId: string;
  Pages: InvoicePage[];
  DetectInvoiceResponse: DetectInvoiceResponse;
  SupplierResult: SupplierResult;
}

export interface SupplierResult {
  SupplierId: string;
  Score: number;
}

export type InvoiceWithoutDetections = Omit<Invoice, 'DetectInvoiceResponse'>;

export interface ImportInvoiceResponse extends BluDeltaResponse {
  Available: boolean;
  InvoiceId: UUID;
  FileName: string;
  File: Base64;
  DetectInvoiceResponse: DetectInvoiceResponse;
}

/**
 * The import document call returns a single invoice together with the prediction result.
 * The client should repeat this call until the property `Available = false`.
 */
export function importInvoice(): Promise<ImportInvoiceResponse> {
  return bludeltaRequest('POST', '/import/invoice');
}

export interface ConfirmInvoiceParams {
  State: number;
  InvoiceId: UUID;
}

export type ConfirmInvoiceResponse = BluDeltaResponse;

/**
 * The confirm invoice call confirms the reception of an invoice document. The Server marks
 * the invoice as transferred and removes it from the list of validatable/importable invoices.
 * If an invoice is not confirmed by the ERP System, it will be moved to the end of the
 * downloadable invoices-list and then provided again.
 */
export function confirmInvoice(params: ConfirmInvoiceParams): Promise<ConfirmInvoiceResponse> {
  return bludeltaRequest('POST', '/confirm/invoice', params);
}

export interface SaveInvoiceParams {
  ContainerId: UUID;
  Invoice: {
    InvoiceId: UUID;
    Pages: { PageNo: number }[];
    DetectInvoiceResponse: DetectInvoiceResponse;
    SupplierResult: SupplierResult;
  };
  BadClientId?: string;
  BadSupplierId?: string;
}

export interface SaveInvoiceResponse extends BluDeltaResponse {
  InvoiceContainers: InvoiceContainer[];
}

/**
 * The confirm invoice call confirms the reception of an invoice document. The Server marks
 * the invoice as transferred and removes it from the list of validatable/importable invoices.
 * If an invoice is not confirmed by the ERP System, it will be moved to the end of the
 * downloadable invoices-list and then provided again.
 */
export async function saveInvoice(params: SaveInvoiceParams) {
  const result = await bludeltaRequest<SaveInvoiceResponse>('POST', '/save/invoice', params);
  normalizeInvoiceContainers(result.InvoiceContainers);
  return result;
}

export interface DeleteInvoiceParams {
  ContainerId: UUID;
  InvoiceId: UUID;
}

export interface DeleteInvoiceResponse extends BluDeltaResponse {
  InvoiceContainers: InvoiceContainer[];
}

export async function deleteInvoice(params: DeleteInvoiceParams) {
  const result = await bludeltaRequest<DeleteInvoiceResponse>('POST', '/delete/invoice', params);
  return result;
}

// export function buildDownloadInvoiceURL(id: UUID) {
//   const token = getToken();
//   return `/api/download/invoice?iid=${id}${token ? `&at=${token}` : ''}`;
// }
export function buildDownloadInvoiceURL(id: UUID) {
  const token = getToken();
  return `/api/download/originalFile?iid=${id}${token ? `&at=${token}&format=json` : ''}`;
}
